import { api } from "../common/http";

const toPage = (res) => res.data;

const CustomersApi = {
  list: async ({ page = 0, size = 20, sort = "createdAt,desc", q, country } = {}) => {
    const params = { page, size, sort };
    if (q) params.q = q;
    if (country) params.country = country;
    const res = await api.get("/customers", { params });
    return toPage(res);
  },

  getAllRecipients: async ({ page = 0, size = 20, sort = "createdAt,desc", q, country } = {}) => {
    const params = { page, size, sort };
    if (q) params.q = q;
    if (country) params.country = country;
    const res = await api.get("/listRecipients", { params });
    return toPage(res);
  },
  getAllSenders: async ({ page = 0, size = 20, sort = "createdAt,desc", q, country } = {}) => {
    const params = { page, size, sort };
    if (q) params.q = q;
    if (country) params.country = country;
    const res = await api.get("/listSenders", { params });
    return toPage(res);
  },

  getById: async (id) => (await api.get(`/customers/${id}`)).data,

  getByUuid: async (uuid) => (await api.get(`/customers/uuid/${uuid}`)).data,

  getTransactionsByRecipientUuid: async (
    uuid,
    { page = 0, size = 10, sort = "createdAt,desc" } = {}
  ) => {
    const params = { page, size, sort };
    const res = await api.get(`/transactions/by-recipient/uuid/${uuid}`, { params });
    return toPage(res);
  },

  getTransactionsByRecipientId: async (
    id,
    { page = 0, size = 10, sort = "createdAt,desc" } = {}
  ) => {
    const params = { page, size, sort };
    const res = await api.get(`/transactions/by-recipient/${id}`, { params });
    return toPage(res);
  },
  
  createForRole: async (role, data) =>
    (await api.post(`/customers`, data, { params: { role } })).data,

  update: async (id, data) => (await api.put(`/customers/${id}`, data)).data,
  updateBasic: async (id, data) => (await api.put(`/customers/${id}`, data)).data,
  remove: async (id) => (await api.delete(`/customers/${id}`)).data,
  removeRoleOrDelete: async (id, role) =>
    (await api.delete(`/customers/${id}`, { params: { role } })).data,
};

export default CustomersApi;
